import { render, staticRenderFns } from "./DragAndDropDecoupled.vue?vue&type=template&id=1b53a2bd&scoped=true"
import script from "./DragAndDropDecoupled.vue?vue&type=script&lang=js"
export * from "./DragAndDropDecoupled.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropDecoupled.vue?vue&type=style&index=0&id=1b53a2bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53a2bd",
  null
  
)

export default component.exports